import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'out-home-difference',
  imports: [CommonModule],
  templateUrl: './home-difference.component.html',
  styleUrl: './home-difference.component.scss',
})
export class HomeDifferenceComponent {
  details = [
    {
      image: '',
      header: 'Only Used Tesla Listings:',
      subText:
        'Find the perfect used Tesla for sale or set your own used Tesla for sale ad live for just $97. Your ad remains active until your car is sold.',
    },
    {
      image: '',
      header: 'Sell Your Tesla:',
      subText:
        "We've got you, we offer a comprehensive pricing strategy, ensuring the best value for your used Tesla for sale.",
    },
    {
      image: '',
      header: 'Boost Your Reach:',
      subText:
        "For an additional $100, enjoy a 10-day Facebook Boost. With the power of Facebook's AI, we spotlight your car across four neighboring states.",
    },
    {
      image: '',
      header: '',
      subText: '',
    },
    {
      image: '',
      header: '',
      subText: '',
    },
    {
      image: '',
      header: '',
      subText: '',
    },
    {
      image: '',
      header: '',
      subText: '',
    },
    {
      image: '',
      header: '',
      subText: '',
    },
  ];
}
